export const TEST_ID = 'skeleton';
